import { t } from "../i18n/index.js";
import { config } from "../config.js";
import { WEAPONS, PASSIVES, HEAL_OPTION, isEvolved } from "../sim/upgrades.js";

// 武器・強化の名前と、レベルアップの選択肢の説明を、今の言語の文にする(文の表は src/i18n/)。

// lv を渡すと、進化した武器は進化後の名前になる
export const weaponName = (id, lv = 0) => (!WEAPONS[id] ? "" : isEvolved(id, lv) ? t(`weapon.${id}.evo.name`) : t(`weapon.${id}.name`));
export const passiveName = (id) => t(`passive.${id}.name`);

// レベルアップの選択肢に出す名前・説明。
// 説明はいつも「何をするものか」だけで、数値の変化は書かない(2026-11-03 オーナー判断「複数の上がり幅まで読む人はあまりいない」)。
// 今どれだけ育っているかは、レーダーチャートのウィンドウ(src/ui/radar.js)で見せる。
export function describeChoice(choice) {
  if (choice.kind === "weapon") {
    const w = WEAPONS[choice.id];
    const name = weaponName(choice.id);
    const what = t(`weapon.${choice.id}.desc`);
    if (choice.level === 1) return { name, desc: t("choice.newWeapon", { desc: what }), level: 1 };
    let desc = what;
    // 最大になる選択肢には、進化のしかたを添える(進化を知ってもらうため)
    if (choice.level === w.levels.length) desc += t("list.sep") + t("choice.evoHint", { passive: passiveName(w.evolution.with), lv: config.evolution.needPassiveLevel });
    return { name, desc, level: choice.level };
  }
  if (choice.kind === "evolve") {
    const desc = t("choice.evolve", { from: weaponName(choice.id), desc: t(`weapon.${choice.id}.evo.desc`) });
    return { name: weaponName(choice.id, choice.level), desc, level: choice.level, evolve: true };
  }
  if (choice.kind === "passive") return { name: passiveName(choice.id), desc: t(`passive.${choice.id}.desc`), level: choice.level };
  return { name: t("heal.name"), desc: t("heal.desc", { n: HEAL_OPTION.amount }), level: 0 };
}
